import { PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet-async';
import { ThemeProvider as BaseThemeProvider } from 'styled-components';

import { useApplicationContext } from '../ApplicationProvider/ApplicationProvider';
import { GlobalStyle } from './ThemeProvider.styled';

/* -------------------------------- Provider -------------------------------- */

const ThemeProvider = ({ children }: PropsWithChildren) => {
    const { theme, config } = useApplicationContext();

    return (
        <BaseThemeProvider theme={theme}>
            <Helmet>
                {/* Favicon */}
                {theme.favicon && (
                    <link rel="shortcut icon" href={theme.favicon} />
                )}

                {/* Client name used for app title */}
                {/* Ensures the title reverts to the client's name after visiting inner pages with page titles */}
                <title>{config.name}</title>
            </Helmet>
            <GlobalStyle />
            {children}
        </BaseThemeProvider>
    );
};

/* --------------------------------- Export --------------------------------- */

export default ThemeProvider;
